import { Component, input, output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ILanguage } from '../interfaces/language.interface';
import { FlagEmojiPipe } from '../pipes/flag-emoji.pipe';

@Component({
  imports: [FlagEmojiPipe, MatFormFieldModule, MatSelectModule],
  selector: 'language-select',
  template: `
    <mat-form-field subscriptSizing="dynamic" style="background: white">
      <mat-select [value]="value()" (selectionChange)="valueChange.emit($event.value)">
        @for (lang of languages(); track lang.code) {
          <mat-option [value]="lang.code">
            {{ lang.flagCode ?? lang.code | flagEmoji }} {{ lang.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  `,
})
export class LanguageSelect {
  protected readonly languages = input.required<ILanguage[]>();

  protected readonly value = input<string>();

  protected readonly valueChange = output<string>();
}
